import React, {useRef, useState} from 'react';
import { useSelections } from '../context/SelectionsContext';
import { useSelectionsListener } from '../hooks/useSelectionsListener';
import { useBodyScrollLock } from '../hooks/useBodyScrollLock';
import { useCartTriggerListener } from '../hooks/useCartTriggerListener';
import { MiniCart } from './elite-selections/MiniCart';
import { ReviewForm } from './elite-selections/ReviewForm';
import {Mailer} from "../utils/Mailer";

export function EliteSelectionsWidget() {
    const {
        selections,
        isOpen,
        showReviewForm,
        addSelection,
        removeSelection,
        openCart,
        closeCart,
        openReviewForm,
        closeReviewForm,
        clearSelections,
    } = useSelections();

    useSelectionsListener(addSelection);
    useBodyScrollLock(isOpen);
    useCartTriggerListener(openCart);
    const pageLoadTimeRef = useRef(performance.now());
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleFormSubmit = (formData) => {
        const submissionData = {
            ...formData,
            selections: selections.map(s => s.toJSON()),
            submitTime: performance.now(),
            pageLoadTime: pageLoadTimeRef.current,
        };
        pageLoadTimeRef.current = performance.now();
        setIsSubmitting(true);

        Mailer.sendEmail({
            ...submissionData,
            url: window.location.href
        }).then( response => {
            if (response.success) {
                clearSelections();
                if(window.top){
                    window.top.location.replace('https://elitehts.com/thank-you?user-selections=1');
                }else{
                    window.location.replace('https://elitehts.com/thank-you?user-selections=1');
                }
                closeCart();
            } else {
                setIsSubmitting(false);
                alert('Something went wrong.');
            }
        }).catch(() => {
            setIsSubmitting(false);
            alert('Something went wrong.');
        });
    };

    return (
        <>
            <MiniCart
                isOpen={isOpen && !showReviewForm}
                selections={selections}
                onClose={closeCart}
                onRemove={removeSelection}
                onReviewClick={openReviewForm}
            />

            <ReviewForm
                isOpen={showReviewForm}
                selections={selections}
                onClose={closeReviewForm}
                onSubmit={handleFormSubmit}
                isSubmitting={isSubmitting}

            />
            {isSubmitting && (
                <div style={{
                    position: 'fixed',
                    inset: 0,
                    background: 'rgba(0, 0, 0, 0.55)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 99999,
                }}>
                    <div style={{
                        width: 52,
                        height: 52,
                        border: '4px solid rgba(255,255,255,0.3)',
                        borderTopColor: '#ffffff',
                        borderRadius: '50%',
                        animation: 'elite-spin 0.75s linear infinite',
                    }} />
                    <p style={{
                        color: '#ffffff',
                        marginTop: 16,
                        fontSize: 15,
                        fontFamily: 'inherit',
                        letterSpacing: '0.02em',
                    }}>
                        Sending your request…
                    </p>
                    <style>{`
                        @keyframes elite-spin {
                            to { transform: rotate(360deg); }
                        }
                    `}</style>
                </div>
            )}
        </>
    );
}
